import root from './_root.js';

/** Built-in value references. */
var Symbol = root.Symbol;

export default Symbol;



//////////////////
// WEBPACK FOOTER
// ./~/redux/~/lodash-es/_Symbol.js
// module id = 374
// module chunks = 0